// Add FollowUp
export const RQ_FOLLOWUP_ADD_API = {
  url: 'api/followup/add',
  method: 'POST',
  auth: true,
};

// Complete FollowUp
export const RQ_FOLLOWUP_COMPLETE_API = {
  url: 'api/followup/complete/<%= id %>',
  method: 'PATCH',
  auth: true,
};

// Today's FollowUps
export const RQ_FOLLOWUP_TODAY_API = {
  url: 'api/followup/today',
  method: 'GET',
  auth: true,
};

// FollowUps By Schedule Date
export const RQ_FOLLOWUP_SCHEDULE_DATE_API = {
  url: 'api/followup/schedule/date',
  method: 'GET',
  auth: true,
};

// Lookup FollowUp By Id
export const RQ_FOLLOWUP_LOOKUP_ID_API = {
  url: 'api/followup/lookup/<%= id %>',
  method: 'GET',
  auth: true,
};

// Lookup FollowUps By Patient
export const RQ_FOLLOWUP_LOOKUP_PATIENT_API = {
  url: 'api/followup/lookup/patient/<%= patientId %>',
  method: 'GET',
  auth: true,
};

// Lookup All FollowUps
export const RQ_FOLLOWUP_LOOKUP_ALL_API = {
  url: 'api/followup/lookup/all',
  method: 'GET',
  auth: true,
};

// Delete FollowUp
export const RQ_FOLLOWUP_DELETE_API = {
  url: 'api/followup/delete/<%= id %>',
  method: 'DELETE',
  auth: true,
};
